/**
 * Composable to lock background scroll when a modal/dialog is open.
 * Sets body to overflow: hidden so the page behind the modal cannot scroll.
 * Use when opening: lock(). Use when closing: unlock().
 */

let lockCount = 0

export function useScrollLock() {
  function lock() {
    lockCount += 1
    if (lockCount > 1) return
    document.body.style.overflow = 'hidden'
  }

  function unlock() {
    if (lockCount <= 0) return
    lockCount -= 1
    if (lockCount > 0) return
    document.body.style.overflow = ''
  }

  return { lock, unlock }
}
